<template>
	<section class="carousel">
		    
    <div>
		  <ul>
		    <li v-for="(item, index) in carousel_slides" :key="'slide-' + index">
			    <div class="slide">{{ item.slide_image.url }}</div>
			    <h2>{{ item.slide_title }}</h2>
			    <h3>{{ item.slide_subtitle }}</h3>
		      <prismic-link :field="item.slide_link" class="btn">
		        <span><strong>{{ item.slide_cta }}</strong></span>
		      </prismic-link>
		    </li>
		  </ul>
		</div>
	    
	</section>
</template>

<script>
export default {
  name: 'Carousel',
  data () {
    return {
    	carousel_slides:[]
    }
  },
	methods: {
		getContent () {
		  this.$prismic.client.getSingle('homepage')
		  	.then((document) => {
			  	this.carousel_slides = document.data.carousel_slides;
		  	})
	  }
	},
	created () {
	  this.getContent();
  }
}
</script>